module.exports = __webpack_public_path__ + "imgs/indica.853ab44e20d037269242d2b91d1cf854.jpg";